import { FormGroup } from '@angular/forms';
import { merge } from 'rxjs';
import { debounceTime, startWith } from 'rxjs/operators';
import { Utilities } from '@core/helpers/utilities';
import { SmartToastService } from '@shared/services/smart-toast.service';
import { getBaseSocialeControl } from '../validators/helpers/base-sociale-form.helper';

const TOAST_DIFFIDA = 'base-sociale.mancata-redazione-regolamento.diffida';

const baseSocialeDiffidaToast = (form: FormGroup, smartToast: SmartToastService): void => {
    const ckNorme = getBaseSocialeControl(form, 'my_CkNormeSocioLavorat');
    const ckRedaz = getBaseSocialeControl(form, 'my_CkRedazRegolam');
    merge(
        ckNorme.valueChanges.pipe(startWith(ckNorme.value)),
        ckRedaz.valueChanges.pipe(startWith(ckRedaz.value))
    )
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(() => {
            smartToast.notify({
                key: TOAST_DIFFIDA,
                condition: ckNorme.value === '1' && ckRedaz.value === '0',
                message: 'La mancata redazione del regolamento comporta la diffida',
                type: 'warning',
            });
        });
};

export const baseSocialeEserciziPrecedentiFlash = {
    annoNonValidoFormato: (smartToast: SmartToastService): void =>
        smartToast.flash("La data termine dell'esercizio precedente non è valida", 'error', 'Anno non valido (inserire 4 cifre)'),

    annoNonValido: (smartToast: SmartToastService): void =>
        smartToast.flash("La data termine dell'esercizio precedente non è valida", 'error', 'Anno non valido'),

    dataFutura: (smartToast: SmartToastService): void =>
        smartToast.flash("La data termine dell'esercizio precedente non è valida", 'error', 'Non è ammissibile una data futura'),
};

export const baseSocialeToastListeners = (form: FormGroup, smartToast: SmartToastService): void => {
    baseSocialeDiffidaToast(form, smartToast);
};
